const errorMessages = {
  EMAIL_NOT_REGISTERED: 'That email address is not registered',
  ACCOUNT_DISABLED: 'This account is disabled',
  EMAIL_NOT_CONFIRMED: 'That email address is not confirmed',
  INCORRECT_EMAIL_PASSWORD: 'Incorrect email or password',
  STUDENT_EMAIL_EXISTS: 'A student with that email already exists in this course group',
  USER_EXISTS_SIGNUP: 'You already have an account. Click below to login',
  USER_ENROLLMENT_EXISTS:
    'You are already enrolled in that course, if you do not see it on your course list please wait for your admin to publish it',
  USER_STUDENT_DEACTIVATED: 'You are deactivated for that course',
  INACTIVE_USER_RESET_PASSWORD: 'Cannot reset the password for an inactive user',
  STAFF_EMAIL_EXISTS: 'A staff member with that email already exists',
  PASSWORDS_DONT_MATCH: "Passwords don't match",
  INVALID_ROLE_STUDENT_SIGNUP: 'You cannot enroll as a student',
  STAFF_EMAIL_NOT_CONFIRMED: 'That email address is not confirmed',
  RESET_PASSWORD_NOT_ALLOWED: 'NULL',
};

export const getErrorMessage = apiErrorMsg => {
  if (!apiErrorMsg) return 'There was an unexpected error';
  const errorMsg = errorMessages[apiErrorMsg];
  return errorMsg || 'There was an unexpected error';
};

// list of error message codes for unified use across platform
export const EMAIL_NOT_CONFIRMED = 'EMAIL_NOT_CONFIRMED';
export const EMAIL_NOT_REGISTERED = 'EMAIL_NOT_REGISTERED';
export const ACCOUNT_DISABLED = 'ACCOUNT_DISABLED';
export const INCORRECT_EMAIL_PASSWORD = 'INCORRECT_EMAIL_PASSWORD';
export const STUDENT_EMAIL_EXISTS = 'STUDENT_EMAIL_EXISTS';
export const USER_EXISTS_SIGNUP = 'USER_EXISTS_SIGNUP';
export const USER_ENROLLMENT_EXISTS = 'USER_ENROLLMENT_EXISTS';
export const USER_STUDENT_DEACTIVATED = 'USER_STUDENT_DEACTIVATED';
export const INACTIVE_USER_RESET_PASSWORD = 'INACTIVE_USER_RESET_PASSWORD';
export const STAFF_EMAIL_EXISTS = 'STAFF_EMAIL_EXISTS';
export const PASSWORDS_DONT_MATCH = 'PASSWORDS_DONT_MATCH';
export const INVALID_ROLE_STUDENT_SIGNUP = 'INVALID_ROLE_STUDENT_SIGNUP';
export const STAFF_EMAIL_NOT_CONFIRMED = 'STAFF_EMAIL_NOT_CONFIRMED';
